<template>
  <nav id="Navbar">
    <div class="row-title">
        <div id="logo">
          <img src="../assets/logo.png" style="max-width:185px;" alt="">
        </div>
        <div id="title">{{ $t("message.montaz_central") }}<span style="text-transform: none;font-size: 15px;">v1.1 beta</span></div>
    </div>
    <div class="row-menu">
      <ul class="nav navbar-nav" v-if="$route.path.replace('/','').indexOf('dopasuj-centrale') > -1 || $route.path.replace('/','').indexOf('dopasuj-obudowe') > -1">
        <li class="menu-item" @click="navbtn = 'centrala'">
          <router-link :class="[($route.path.replace('/','') === '') ? 'activeNav' : '']" to="/">{{ $t("message.wroc") }}</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
// import Services from '../components/Services'
export default {
  name: "Navbar",
  data () {
    return {
      navbtn: 'centrala'
    }
  },
  components: {
    // Services
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Play:wght@700&display=swap');

#Navbar {
  background-color: #d0d0d0;
  width: 100%;
}
.row-title {
  display: flow-root list-item;
}
#title {
font-size: 38px;
margin: 20px;
text-transform: uppercase;
font-family: 'Play', sans-serif;
line-height: 32px;
}
#logo {
  max-width:210px;
  float: left;
}
#logo img{
  width:100%;
  margin: 10px;
}

.row-menu {
width: 100%;
height: 30px !important;
background: #b9b9b9;
}

.navbar-nav {
  display: block;
}

#Navbar ul {
  list-style-type: none;
  padding: 0;
  overflow: hidden;
  height:30px;
}
#Navbar ul li {
float: right;
height: 30px;
line-height: 30px;
background: #3a4147;
margin-right: 2px;
}
#Navbar ul li a {
  color: white;
  text-align: center;
  padding: 0px 25px;
  display: block;
  text-decoration: none;
}
#Navbar ul li a:hover {
  background-color: #0c6dd5;
}

.activeNav {
  background-color: #0c6dd5;
}
.active {
  background-color: #04aa6d;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue